export default __webpack_public_path__ + "static/media/CEEK.03b5a878.png";